import { request } from "../../Services/Api"

export const inviteByEmail = (data) => request.api.post(`/referral/config/invite_by_mail/`, data)

export const getYourCommissions = () => request.api.get(`/referral/config/your_commissions/`)

export const getInviteLink = () => request.api.get("/referral/config/invite_link/")

export const referralsTable = (params) =>
  request.api.get("/referral/earnings/referrals-table/", params)

export const getFaq = () => request.api.get("/referral/faq/")

export const getTotalStatistics = (params) =>
  request.api.get("/referral/earnings/total-statistics", params)

export const getReferralsOverviewData = (params) =>
  request.api.get("/referral/charts/rewards", params)

export const getReferralsOverviewMainInfo = (params) =>
  request.api.get("/referral/charts/main-info", params)

export const getReferralBAOptions = (params) =>
  request.api.get("/referral/charts/business-accounts", params)

export const getAlertsBySourceTable = (params) =>
  request.api.get("/referral/charts/by-source", params)

export const getAdminStatisticBlocks = (params) =>
  request.api.get("/referral/admin/statistic-blocks", params)

export const getAdminStatisticBlockChart = ({ chartType, params }) => {
  return request.api.get(`/referral/admin/${chartType}`, params)
}

export const getAdminTable = (params) => request.api.get("/referral/admin/referrals-table", params)

export const exportAdminTable = (params) =>
  request.api.get("/referral/admin/referrals-table-export", params)

export const getAdminTableAlertsChart = ({ business_account_id, params }) =>
  request.api.get(`/user/business-account/${business_account_id}/alerts_statistics`, params)

export const getAdminTableRewardChart = ({ params }) =>
  request.api.get("/referral/admin/rewarded-chart/", { ...params })

export const getOutsiderBlocks = (params) => request.api.get("/referral/outsider/blocks/", params)

export const outsiderWithdraw = (data) => request.api.post("/referral/outsider/withdraw/", data)

export const getOutsiderPayoutMethod = (params) =>
  request.api.get("/referral/outsider/payout-method/", params)

export const addOutsiderPayoutMethod = (data) =>
  request.api.post("/referral/outsider/payout-method/", data)

export const updateOutsiderPayoutMethod = (data) =>
  request.api.put("/referral/outsider/payout-method/", data)

export const getOutsiderWithdrawalsHistory = () =>
  request.api.get("/referral/outsider/withdrawals-history/")

export const getWithdrawalRequests = (params) =>
  request.api.get("/referral/admin/withdrawals/", params)

export const getWithdrawalRequestPayoutMethod = (id) =>
  request.api.get(`/referral/admin/withdrawals/${id}/payout-method/`)

export const updateWithdrawalRequestStatus = ({ id, status }) =>
  request.api.post(`referral/admin/withdrawals/${id}/set-status/${status}/`)

export const getReferralBusinessAccountInfo = (id) =>
  request.api.get(`/referral/admin/ba-user-main-info?business_account_id=${id}`)

export const countryCodes = () => request.api.get("/referral/earnings/country-codes/")
